<template>
  <div class="materials-wrapper">
    <ul>
      <slot />
    </ul>
  </div>
</template>

<script>
export default {
  name: "Materials"
};
</script>

<style lang="scss" scoped>
.materials-wrapper {
  display: flex;
  /* justify-content: center; */
  width: 100vw;
  padding-bottom: 32px;
  margin-bottom: 0;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;

  ul {
    display: flex;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 0 10vw;
    list-style-type: none;
  }
}
</style>
